/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import Layout from '../../components/Layout';
import Page from '../../components/Page';

export default {

  path: '/about',

  async action() {
    const title = 'About Martin Loncaric';
    const component = (
      <Layout>
        <Page title={title}>
          I work on mathematical/ML models, develop software, and know how to
          make decent egg scrambles.
          <br />
          <br />
          I started Graph All The Things because I had various math questions I
          wanted to investigate.
          In the spirit of making something people want to read,
          I'm not always very rigorous, but I try to give a high-level derivation.
          I apply math and coding to a wide variety of topics.
          Let me know if I've overlooked something.
          <br />
          <br />
          For any job offers, questions, concerns, or threats, please contact
          me at m.w.loncaric@gmail.com.
        </Page>
      </Layout>
    );

    return {
      title,
      description: 'about Martin Loncaric and Graph All The Things',
      component,
    };
  },

};



// WEBPACK FOOTER //
// src/routes/about/index.js